import { render, staticRenderFns } from "./PosteMatching.vue?vue&type=template&id=250e361d&scoped=true&"
import script from "./PosteMatching.vue?vue&type=script&lang=ts&"
export * from "./PosteMatching.vue?vue&type=script&lang=ts&"
import style0 from "./PosteMatching.vue?vue&type=style&index=0&id=250e361d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e361d",
  null
  
)

export default component.exports